export const STATUS_LABELS = {
  open: 'Non jouée',
  won: 'Gagné · à remettre',
  lost: 'Sans lot',
  delivered: 'Lot remis',
  cancelled: 'Annulée',
};

const STATUS_BADGES = {
  open: 'bg-secondary',
  won: 'bg-warning text-dark',
  lost: 'bg-light text-dark border',
  delivered: 'bg-success',
  cancelled: 'bg-danger',
};

export function StatusBadge({ status }) {
  return <span className={`badge ${STATUS_BADGES[status] || 'bg-secondary'}`}>{STATUS_LABELS[status] || status}</span>;
}

export function fmtTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  return sameDay
    ? d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function fmtDateTime(iso) {
  return iso ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '';
}

/** Valeur pour <input type="datetime-local"> dans le fuseau du navigateur. */
export function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** datetime-local → ISO avec décalage du navigateur (évite toute ambiguïté de fuseau). */
export function fromLocalInput(value) {
  if (!value) return null;
  return new Date(value).toISOString();
}
